// plugins/loading.js
import { ref, createApp, h } from 'vue';
import MyLoading from '~/components/MyLoading.vue';

export default defineNuxtPlugin((nuxtApp) => {
  const isLoading = ref(false);

  const showLoading = () => {
    isLoading.value = true;

    // 创建一个新的 Vue 应用实例
    const loadingApp = createApp({
      render: () => h(MyLoading),
    });

    // 挂载到一个新的 DOM 节点
    const container = document.createElement('div');
    document.body.appendChild(container);
    loadingApp.mount(container);
  };

  const hideLoading = () => {
    isLoading.value = false;
    // 这里可以添加逻辑来卸载组件
    const loadingElement = document.querySelector('.root-box');
    if (loadingElement) {
      loadingElement.remove(); // 移除 loading 组件
    }
  };

  // 挂载到 Vue 实例
  nuxtApp.$loading = {
    isLoading,
    showLoading,
    hideLoading,
  };
});